// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"65059cb8","619":"908bd386"}[chunkId] + ".chunk.js";
};